<template>
  <div class="index">
    <Kv :scrollToForm="scrollToForm" />
    <Article :scrollToForm="scrollToForm" />
    <!-- Form -->
    <section class="form">
      <div class="container">
        <div class="form-title">
          FiveStones Data-driven Creative ROI Calculator
        </div>
        <div class="form-description">
          Enter your creative specifications and requirements below to calculate
          the ROI and savings you could generate from using a Dynamic Creative
          Template and Data-driven Creative:
        </div>
        <div class="form-note">
          <div class="form-note-icon">
            <img src="./../assets/notes.svg" alt="" />
          </div>
          <div class="form-note-text">
            Note: This calculation is based on the cost saving from building &
            trafficking of Dynamic Data-driven Creative in partnership with
            FiveStones for the input information compared to manually building &
            trafficking of creative.
          </div>
        </div>
        <div class="calcRoi">
          <CalculateROI
            :numOfSizes.sync="form.numOfSizes"
            :numOfFrames.sync="form.numOfFrames"
            :numOfVariations.sync="form.numOfVariations"
            @calculateRoiResponse="calculateRoiResponse"
          />
          <transition name="fade">
            <CalculateROIResult
              v-if="calculateRoiResult.budgetSaved"
              :budgetSaved="form.budgetSaved"
              :hoursSaved="form.hoursSaved"
              :contactFormShow.sync="contactFormShow"
            />
          </transition>
        </div>
        <transition name="fade">
          <ContactForm
            v-if="contactFormShow"
            :form.sync="form"
            :numCountry="numCountry"
            @budgetSaved="budgetSavedHandler"
          />
        </transition>
      </div>
    </section>
    <Privacy />
  </div>
</template>

<script>
import $ from 'jquery'
import Kv from '../components/Kv'
import Article from '../components/Article'
import SubmitMessage from '../components/SubmitMessage'
import Privacy from '../components/Privacy'
import CalculateROI from '../components/CalculateROI'
import CalculateROIResult from '../components/CalculateROIResult'
import ContactForm from '../components/ContactForm'

export default {
  name: 'index',
  components: {
    Kv,
    Article,
    SubmitMessage,
    Privacy,
    CalculateROI,
    CalculateROIResult,
    ContactForm
  },
  data() {
    return {
      form: {
        formName: 'ddc-roi-calculator',
        date: '',
        name: '',
        email: '',
        job: '',
        company: '',
        country: '',
        'contact-fs-office': '',
        numOfSizes: '',
        numOfFrames: '',
        numOfVariations: '',
        budgetSaved: '',
        hoursSaved: ''
      },
      calculateRoiResult: {},
      contactFormShow: false,
      numCountry: {
        Australia: 'AUD',
        'New Zealand': 'AUD',
        'Hong Kong': 'HKD',
        China: 'CNY',
        Taiwan: 'TWD',
        Singapore: 'SGD',
        Indonesia: 'IDR',
        'South Korea': 'KRW',
        Philippines: 'USD',
        Thailand: 'THB',
        Other: 'USD'
      }
    }
  },
  mounted() {
    setTimeout(() => {
      let marginTop = $('.header').innerHeight()
      $('.main').css({ marginTop: marginTop })
    }, 100)
  },
  methods: {
    scrollToForm() {
      let formTop = $('.form').offset().top
      let headerH = $('.header').innerHeight()
      $('html, body').animate({ scrollTop: formTop - headerH - 30 })
    },
    budgetSavedHandler() {
      if (!this.calculateRoiResult.budgetSaved) {
        this.form.budgetSaved = ''
      } else {
        let currency = !this.form.country
          ? 'USD'
          : this.numCountry[this.form.country]
        let doller = this.calculateRoiResult.budgetSaved[currency]

        this.form.budgetSaved = `${currency} ${doller}`
      }
    },
    hoursSavedHandler() {
      let hours = this.calculateRoiResult.hoursSaved
      if (hours <= 0 || hours == undefined) return '-'
      this.form.hoursSaved = hours
    },
    roiDatalayerPush() {
      let vm = this
      this.$gtm.trackEvent({
        event: 'calculateRoi',
        details: {
          numOfSizes: vm.form.numOfSizes,
          numOfFrames: vm.form.numOfFrames,
          numOfVariations: vm.form.numOfVariations,
          budgetSaved: vm.form.budgetSaved,
          hoursSaved: vm.form.hoursSaved
        }
      })
    },
    calculateRoiResponse(response) {
      this.calculateRoiResult = response.data
      this.budgetSavedHandler()
      this.hoursSavedHandler()
      this.roiDatalayerPush()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue